import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';
import AddressDisplay from 'components/FrictionlessCheckout/DeliverToReleaseThree/AddressDisplay/AddressDisplay';
import { orderDetailsSelector } from 'selectors/order/orderDetails/orderDetailsSelector';
import checkoutUtils from 'utils/Checkout';
import orderUtils from 'utils/Order';
import AddressDisplayEN from 'components/FrictionlessCheckout/DeliverToReleaseThree/AddressDisplay/locales/AddressDisplay_en_US';
import AddressDisplayFR from 'components/FrictionlessCheckout/DeliverToReleaseThree/AddressDisplay/locales/AddressDisplay_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(AddressDisplayEN, AddressDisplayFR);

const localizationSelector = createStructuredSelector({
    edit: getTextFromResource(getText, 'edit'),
    changeShippingAddress: getTextFromResource(getText, 'changeShippingAddress')
});

const fields = createSelector(
    (_ownState, ownProps) => ownProps.isGiftCardSection,
    orderDetailsSelector,
    localizationSelector,
    (isGiftCardSection, orderDetails, localization) => {
        const isGuestCheckout = checkoutUtils.isGuestOrder();
        const isGiftCardOnlyOrder = orderUtils.isGiftCardOnly();

        const shouldShowEmailAddressInGiftCardSection = isGuestCheckout && isGiftCardOnlyOrder && isGiftCardSection;
        const shouldShowEmailFieldOutsideGiftCardSection = isGuestCheckout && !isGiftCardSection && !shouldShowEmailAddressInGiftCardSection;

        const shouldDisplayEmailAddress = shouldShowEmailAddressInGiftCardSection || shouldShowEmailFieldOutsideGiftCardSection;

        return {
            localization,
            shouldDisplayEmailAddress
        };
    }
);

const withComponentProps = wrapHOC(connect(fields, null));

export default withComponentProps(AddressDisplay);
